<template>
    <div>
        <BOverlay :show="is_load" rounded="sm">
            <div class="app_vue_list" >
                <!-- filter -->
                <div class="filter_block mb-3">
                    <list_filter @search_called="handleSearch" @clean_filter="handleCleanFilters"></list_filter>
                </div>
                
                <template v-if="(Array.isArray(rows) ? rows.length === 0 : true)">
                    <div class="text-center text-muted py-5 border rounded">
                        <i class="far fa-folder-open fa-2x d-block mb-2"></i>
                        Немає активних тендерів
                    </div>
                </template>
                
                <BTable v-if="rows.length > 0"  :thead-class="head_class" :tbody-tr-class="rowClass" responsive :items="rows" :fields="table_fields">
                    <template #empty>
                        <div class="text-center text-muted py-5">
                            <i class="far fa-folder-open fa-2x d-block mb-2"></i>
                            Немає активних тендерів
                        </div>
                    </template>
                    
                    <!-- HEAD FIELDS -->
                    <template v-slot:head(id)="data">
                        <grid :list_ordering="'id'" field_name="ID" :current_ordering="list.ordering" :current_direction="list.direction" @update-order="handleOrdering"/>
                    </template>
                    
                    
                    <template v-slot:head(number)="data">
                        <grid :list_ordering="'number'" field_name="Номер" :current_ordering="list.ordering" :current_direction="list.direction" @update-order="handleOrdering"/>
                    </template>
                    
                    <template v-slot:head(name)="data">
                        <grid :list_ordering="'name'" field_name="Назва" :current_ordering="list.ordering" :current_direction="list.direction" @update-order="handleOrdering"/>
                    </template>
                    
                    <template v-slot:head(date_from)="data">
                        <grid :list_ordering="'date_from'" field_name="Початок" :current_ordering="list.ordering" :current_direction="list.direction" @update-order="handleOrdering"/>
                    </template>
                    
                    <template v-slot:head(date_to)="data">
                        <grid :list_ordering="'date_to'" field_name="Завершення" :current_ordering="list.ordering" :current_direction="list.direction" @update-order="handleOrdering"/>
                    </template>
                    
                    <template v-slot:cell(actions)="row">
                        <tenderInfo
                            :row="row.item"
                            :href="row.item.href"
                        ></tenderInfo>
                    </template>
                    
                    <template  v-slot:cell(name)="data">
                        {{tender_name(data.item)}}
                    </template>
                
                    
                </BTable>
            </div>
            
            <div class="pt-4" v-if="rows.length > 0">
                <pagination
                    key="down"
                    :total="pagination.total"
                    :limit="pagination.limit"
                    :current="pagination.pagesCurrent"
                    @page-change="handlePageChange">
                </pagination>
            </div>
        
        </BOverlay>
    </div>
</template>


<script>


import {
    BButton,
    BTable,
    BOverlay,
} from 'bootstrap-vue-next';

import grid from "../../../../shared/list/grid/grid.vue";
import pagination from "../../../../shared/list/pagination/pagination.vue";
import List_filter from "../../../../shared/list/filter/list_filter.vue";
import tenderInfo from "./tender/tenderInfo.vue";
import {mapGetters} from "vuex";


export default {
    name: "tender_table",
    
    props : {
        has_tender_all : {
            type : Boolean,
            default : false,
        }
    },
    
    components : {
        tenderInfo,
        List_filter,
        BTable,
        BOverlay,
        BButton,
        grid,
        pagination
    },
    
    data() {
        return {
            rows : [],
            is_load : true,
            
            list: {
                ordering: "id",
                direction: "DESC",
                start: 0,
                limit: 30
            },
            
            pagination: {
                total: 0,
                limit: 30,
                pagesCurrent: 1
            },
            
            filter: {
                search: "",
                provider_id: "",
                city_id: "",
                rest_group: ""
            },
            
            fields : [
                {key:'id', label:'t.id', class:'text-center hidden-md-down', visible:true},
                {key:'number', label:'t.number', class:'tender_pre_name', visible:true},
                {key:'name', label:'t.name', class:'tender_pre_name', visible: true},
                {key:'date_from', label:'t.date_from', class:'text-center hidden-sm-down', visible:true},
                {key:'date_to', label:'t.date_to', class:'text-center hidden-sm-down', visible:true},
                {key:'actions', label:'', class:'tender_pre_name', visible:true},
            ],
            
        }
    },
    
    mounted() {
        this.load_items();
    },
    
    created() {
    
    },
    
    methods : {
        tender_name(item) {
            let res = item.name;
            switch (item.tender_type) {
                case "first_simple":
                    res = item.name;
                    break;
                case "second_simple":
                    res = item.name+' (Другий тур)';
                    break;
                case "second_reduction":
                    res = item.name+' (Редукціон)';
                    break;
            }
            return res;
        
        },
        
        handleOrdering({ordering, direction}) {
            this.list.ordering = ordering;
            this.list.direction = direction;
            this.load_items();
        },
        
        handlePageChange({page, start}) {
            this.list.start = start;
            this.load_items();
        },
        
        handleSearch(search_str) {
            this.filter.search = search_str;
            this.list.start = 0;
            this.load_items();
        },
        
        handleCleanFilters() {
            
            this.filter = {
                search: "",
            };
            
            this.list = {
                ordering: "ordering",
                direction: "DESC",
                start: 0,
                limit: 30
            };
            
            this.list.start = 0;
            this.load_items();
        },
        
        edit_view(item) {
            if ((item.status == 'new') || (item.status == 'reject')) {
                window.location = this.href_edit + item.id;
            } else {
                window.location = this.href_view + item.id;
            }
        },
        
        filter_select(res) {
            this.filter[res.type] = res.value;
            this.list.start = 0;
            this.load_items();
        },
        
        async load_items() {
            this.is_load = true;
            this.rows = [];
            
            this.filter.has_tender_all = this.has_tender_all;
            let url = '/tenders/list';
            
            await api.post(url,{
                filter  : this.filter,
                list    : this.list
            }).then(({data}) => {
                this.is_load = false;
                if(data.status === "operation_success") {
                    this.rows = data.data;
                    if (data.message?.pagination) {
                        this.pagination = data.message.pagination;
                    }
                }
            }).catch(response => {
                this.is_load = false;
                this.rows = [];
                
                EventBus.$emit('show_toast', {
                    err: response.data.message,
                    type: "danger",
                    title: response.data.status
                });
            })
        },
        
        rowClass(item) {
            if (!item) return;
            return 'app_' + item.status;
        }
    },
    
    computed : {
        ...mapGetters({
            'user': "user/getUser",
        }),
        
        head_class() {
        },
        
        table_fields() {
            return this.fields;
        }
        
        
        
    }
    
}
</script>


<style scoped>

</style>